import * as actionTypes from './types';
import { updateObject } from '../utility'; 

const initialState = {
  reportId: null,
  tempReportId: null,
  farmId: '',
  errorMsg: '',
  successMsg: '',
  loading: false,
  user: {},
  countries: [],
  farmOwners: [],
  offices: [],
  organisations: [],
  assignableRoles: [],
  allRoles:{},
  siteAdmin: null,
  backendVersion: {}
}

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_REPORT_ID: return setReportId(state, action);
    case actionTypes.SET_TEMP_REPORT_ID: return setTempReportId(state, action);
    case actionTypes.RESPONSE_STATE_SUCCESS: return responseStateSuccess(state, action);
    case actionTypes.RESPONSE_STATE_FAIL: return responseStateFail(state, action);
    case actionTypes.SET_LOADING: return setLoadingState(state, true);
    case actionTypes.UNSET_LOADING: return setLoadingState(state, false);
    case actionTypes.RESET_RESPONSE_STATE: return resetResponseState(state, action);
    case actionTypes.SET_USER: return setUserDetails(state, action);
    case actionTypes.GET_ALL_COUNTRIES_SUCCESS: return setCountries(state, action);
    case actionTypes.GET_FARM_OWNERS_DATA_SUCCESS: return setFarmOwnerDataSuccess(state, action);
    case actionTypes.GET_FARM_OWNERS_DATA_FAIL: return setFarmOwnerDataFail(state, action);
    case actionTypes.GET_OFFICE_DATA_SUCCESS: return setOfficeDataSuccess(state, action);
    case actionTypes.GET_OFFICE_DATA_FAIL: return setOfficeDataFail(state, action);
    case actionTypes.GET_ORGANISATION_DATA_SUCCESS: return setOrganisationDataSuccess(state, action);
    case actionTypes.GET_ORGANISATION_DATA_FAIL: return setOrganisationDataFail(state, action);
    case actionTypes.GET_USER_ASSIGNABLE_ROLE_DATA_SUCCESS: return setAssignableUserRolesSuccess(state, action);
    case actionTypes.GET_USER_ASSIGNABLE_ROLE_DATA_FAIL: return setAssignableUserRolesFail(state, action);
    case actionTypes.GET_ALL_USER_ROLES_DATA_SUCCESS: return setAllUserRolesSuccess(state, action);
    case actionTypes.GET_ALL_USER_ROLES_DATA_FAIL: return setAllUserRolesFail(state, action);
    case actionTypes.GET_BACKEND_VERSION_SUCCESS: return setBackendVersion(state, action);
    case actionTypes.GET_BACKEND_VERSION_FAIL: return setBackendVersion(state, action);
    case actionTypes.GET_SITE_ADMIN_DATA_SUCCESS: return setSiteAdminData(state, action);
    case actionTypes.GET_SITE_ADMIN_DATA_FAIL: return setSiteAdminData(state, action);
    default:
      return state;
  }
}

const setReportId = (state, action) => {
  const updatedState = {
    reportId: action.payload,
    tempReportId: null
  }
  return updateObject(state, updatedState);
}

const setTempReportId = (state, action) => {
  const updatedState = {
    reportId: null,
    tempReportId: state.reportId
  }
  return updateObject(state, updatedState);
}

const responseStateSuccess = (state, action) => {
  const updatedState = {
    successMsg: action.payload
  }
  return updateObject(state, updatedState);
}

const responseStateFail = (state, action) => {
  const updatedState = {
    errorMsg: action.payload
  }
  return updateObject(state, updatedState);
}

const setLoadingState = (state, isLoading) => {
  const updatedState = {
    loading: isLoading
  }
  return updateObject(state, updatedState);
}

const resetResponseState = (state, action) => {
  const updatedState = {
    errorMsg: '',
    successMsg: ''
  }
  return updateObject(state, updatedState);
}

const setUserDetails = (state, action) => {
  const updatedState = {
    user: action.payload,
  }
  return updateObject(state, updatedState);
}

const setCountries = (state, action) => {
  const updatedState = {
    countries: action.payload,
  }
  return updateObject(state, updatedState);
}


const setOfficeDataSuccess = (state, action) => {
  const updatedState = {
    offices: action.payload,
  }
  return updateObject(state, updatedState);
}

const setOfficeDataFail = (state, action) => {
  const updatedState = {
    offices: [],
  }
  return updateObject(state, updatedState);
}

const setOrganisationDataSuccess = (state, action) => {
  const updatedState = {
    organisations: action.payload,
  }
  return updateObject(state, updatedState);
}

const setOrganisationDataFail = (state, action) => {
  const updatedState = {
    organisations: {},
  }
  return updateObject(state, updatedState);
}

const setFarmOwnerDataSuccess = (state, action) => {
  const updatedState = {
    farmOwners: action.payload,
  }
  return updateObject(state, updatedState);
}

const setFarmOwnerDataFail = (state, action) => {
  const updatedState = {
    farmOwners: {},
  }
  return updateObject(state, updatedState);
}

const setAssignableUserRolesSuccess = (state, action) => {
  const updatedState = {
    assignableRoles: action.payload,
  }
  return updateObject(state, updatedState);
}

const setAssignableUserRolesFail = (state, action) => {
  const updatedState = {
    assignableRoles: {},
  }
  return updateObject(state, updatedState);
}

const setAllUserRolesSuccess = (state, action) => {
  let ar = {}
  for (const role of action.payload) {
    ar[role.name] = {
      displayName: role?.extraProperties?.DisplayName,
      canSelfAssign: role?.extraProperties?.canSelfAssign,
      isPublic: role?.isPublic
    }
  }
  const updatedState = { allRoles: ar }

  return updateObject(state, updatedState);
}

const setAllUserRolesFail = (state, action) => {
  const updatedState = {
    allRoles: {},
  }
  return updateObject(state, updatedState);
}


const setBackendVersion = (state, action) => {
  const updatedState = {
    backendVersion: action.payload,
  }
  return updateObject(state, updatedState);
}

const setSiteAdminData = (state, action) => {
  const updatedState = {
    siteAdmin: action.payload,
  }
  return updateObject(state, updatedState);
}

export default commonReducer;
